<template>
  <b-avatar :src="photo" :size="size" :rounded="rounded" :class="avatarClass" @img-error="onImgError">
    <component :is="defaultPhoto" v-if="!photo" :style="{ fontSize: fontSize || size }" />
  </b-avatar>
</template>

<script>
import MemberAvatar from '@/assets/images/avatar.svg'
import TeamAvatar from '@/assets/images/team-avatar.svg'
import TeamIcon from '@/assets/images/team.svg'

export default {
  name: 'Avatar',

  props: {
    src: {
      type: String
    },

    size: {
      type: String
    },

    fontSize: {
      type: String
    },

    rounded: {
      type: String
    },

    variant: {
      type: String,
      default: 'user',
      validator(value) {
        return ['user', 'team', 'teambig'].indexOf !== -1
      }
    },

    defaultSvg: {
      type: Object
    }
  },

  computed: {
    photo() {
      return this.error ? null : this.src
    },

    defaultPhoto() {
      if (this.defaultSvg) return this.defaultSvg
      switch (this.variant) {
        case 'user': return MemberAvatar
        case 'team': return TeamAvatar
        case 'teambig': return TeamIcon
        default: return 'div'
      }
    },

    avatarClass() {
      return this.variant !== 'teambig' ? 'badge-avatar' : ''
    }
  },

  data() {
    return {
      error: false
    }
  },

  methods: {
    onImgError(who) {
      this.error = true
    }
  },

  components: {
    MemberAvatar,
    TeamAvatar,
    TeamIcon
  }
}
</script>
